/*!*
 * @author yueheqin
 * @date 2019/7/3
 * @project zujuanzaixian
 * @desc
 */

import Bus from 'vue'
let install = function (Vue) {
  Vue.prototype.bus = new Bus()
}

export default {install}
